import FetchFactory, {
	DeleteRequest,
	GetRequest,
	ModifyRequest
} from "utils/fetch/FetchRequest";
import { AddLibraryBlueprint, LibraryBlueprint } from "./LibraryTypes";

const ENDPOINT = "/api/library";

export default class LibraryClient {
	public static getAll(): GetRequest<Array<LibraryBlueprint>> {
		return FetchFactory.get(ENDPOINT);
	}

	public static get(id: number): GetRequest<LibraryBlueprint> {
		return FetchFactory.get(`${ENDPOINT}/${id}`);
	}

	public static add(id: number): ModifyRequest<AddLibraryBlueprint, void> {
		return {
			operation: "POST",
			url: ENDPOINT,
			body: { id },
			statusCode: 201,
			callback: () => Promise.resolve()
		};
	}

	public static remove(id: number): DeleteRequest<void> {
		return FetchFactory.del(`${ENDPOINT}/${id}`);
	}
}
